import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { isEmpty, isLoaded, useFirestoreConnect } from "react-redux-firebase";
import { Link, Redirect } from "react-router-dom";
import LoadingIndicator from "../../../components/common/LoadingIndicator";
import UpdateSectionForm from "../../../components/forms/menu/UpdateSectionForm";
import { ADMIN_MENU_PATH } from "../../../constants/paths";
import MdTrash from "react-ionicons/lib/MdTrash";
import ModalDelete from "../../../components/common/ModalDelete";
import ModalLoading from "../../../components/common/ModalLoading";
import {
  resetDeleteSection,
  deleteSection,
  updateProductOrder,
} from "../../../store/actions/RestaurantActions";
import ProductDragAndDrop from "../../../components/menu/ProductDragAndDrop";
import BackButton from "../../../components/common/BackButton";

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const SectionPage = ({
  match,
  loading,
  success,
  error,
  deleteSection,
  resetDeleteSection,
  updateProductOrder,
}) => {
  const [restaurantId, setRestaurantId] = useState("nothing");
  const [products, setProducts] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useFirestoreConnect([
    {
      collection: "categories",
      doc: match.params.id,
      storeAs: `section-${match.params.id}`,
    },
    {
      collection: "categories",
      doc: match.params.id,
      subcollections: [{ collection: "products", orderBy: [["order", "asc"]] }],
      storeAs: `section-${match.params.id}-products`,
    },
  ]);

  const section = useSelector(
    ({ firestore }) => firestore.data[`section-${match.params.id}`]
  );

  const productsFirebase = useSelector(
    ({ firestore }) => firestore.ordered[`section-${match.params.id}-products`]
  );

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      products,
      result.source.index,
      result.destination.index
    );

    setProducts(items);
  };

  useEffect(() => {
    if (isLoaded(productsFirebase)) setProducts(productsFirebase);
  }, [productsFirebase]);

  if (!isLoaded(section) || !isLoaded(products))
    return <LoadingIndicator></LoadingIndicator>;

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleDelete = () => {
    closeModal();
    deleteSection(match.params.id);
  };

  if (success || isEmpty(section)) {
    resetDeleteSection();
    return <Redirect to={ADMIN_MENU_PATH}></Redirect>;
  }

  return (
    <div className="px-16 py-8 text-gray-900">
      <ModalLoading
        message="Se están realizando los cambios en la base de datos. Espere un momento por favor."
        closeModal={null}
        modalIsOpen={loading}
        shouldCloseOnEsc={false}
        shouldCloseOnOverlayClick={false}
        subtitle=""
        title="Modificando datos"
        loading
      ></ModalLoading>
      <ModalDelete
        message="¿Estás seguro que quieres borrar los datos del producto?
                    Todos los datos serán perdidos permanentemente. Esta acción
                    no se puede revertir."
        closeModal={closeModal}
        modalIsOpen={isModalOpen}
        shouldCloseOnEsc
        shouldCloseOnOverlayClick
        subtitle={section.title}
        title="Borrar producto"
        remove={handleDelete}
      ></ModalDelete>
      <BackButton />
      <div className="bg-white mt-4 shadow-sm border rounded-sm">
        <p className="px-6 py-3 border-b flex justify-between">
          {section.title}
          <MdTrash onClick={openModal}></MdTrash>
        </p>
        <div className="bg-gray-100 px-6 py-3 relative text-gray-700 text-md">
          <div className="menu">
            <UpdateSectionForm
              {...section}
              id={match.params.id}
              imageUrl={section.image}
              restaurantId={restaurantId}
            ></UpdateSectionForm>
            <h2 className="font-bold text-lg mb-2 mt-4">
              <hr className="mb-2"></hr>
              Productos
            </h2>
            <ProductDragAndDrop
              products={products}
              sectionId={match.params.id}
              onDragEnd={onDragEnd}
            ></ProductDragAndDrop>
            <div className="flex justify-end items-center">
              <button
                className="ml-6 text-gray-700 py-2 px-4 text-sm font-bold"
                onClick={() =>
                  updateProductOrder(products, restaurantId, match.params.id)
                }
              >
                Actualizar orden
              </button>
              <Link
                to={`${ADMIN_MENU_PATH}/seccion/${match.params.id}/producto/nuevo`}
                type="button"
                className="bg-gray-300 rounded-md text-gray-700 py-2 px-4 text-sm font-bold border-2 border-gray-500"
              >
                Agregar producto
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return { ...state.restaurant.sectionActions.delete };
};

const mapDispatchToProps = (dispatch) => {
  return {
    deleteSection: (sectionId) => dispatch(deleteSection(sectionId)),
    resetDeleteSection: () => {
      dispatch(resetDeleteSection());
    },
    updateProductOrder: (products, sectionId) =>
      dispatch(updateProductOrder(products, sectionId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SectionPage);
